'use strict';
angular.module('resourceCenterMaterialModule').directive('tagsSelect', ['$timeout',
    function($timeout) {
        return {
            scope: {
                options: '=',
                selectedOptions: '=',
                searchWords: '=',
                callback: '&',
                nameKey: '@',
                valueKey: '@',
                select: '&',
                delete: '&'
            },
            restrict: 'EA',
            templateUrl: './resourceCenter/materialResource/directive/initTagsSelect/index.html',
            replace: true,
            link: function($scope, iEle) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.options = $scope.options || [];
                    $scope.selectedOptions = $scope.selectedOptions || [];
                    $scope.nameKey = $scope.nameKey || '';
                    $scope.valueKey = $scope.valueKey || '';
                    $scope.data = {
                        selected: []
                    };
                }

                /**
                 * [initData description] 初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    bindBlur();
                }
    
                /**
                 * [loadTags description] 选择标签输入框回调函数
                 * @param   {[type]}  val  [val description] 输入值
                 * @return  {[type]}       [return description]
                 */
                $scope.loadTags = function(val) {
                    $scope.options = [];
                    if ($scope.searchWords) {
                        $timeout(function() {
                            $scope.callback();
                        });
                    }
                    return Promise.resolve([]);
                };

                /**
                 * [deleteTag description] 删除标签操作函数
                 *
                 * @param   {[type]}  $tag  [$tag description] 删除的标签对象
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.deleteTag = function($tag) {
                    $scope.options = [];
                    $scope.searchWords = '';
                    $scope.delete($tag);
                };

                /**
                 * [selectTag description] 选中标签回调函数
                 * @param   {[type]}  tag  [tag description]
                 * @return  {[type]}       [return description]
                 */
                $scope.selectTag = function(tag) {
                    $scope.searchWords = '';
                    var index = $scope.checkedTags(tag);
                    if (index > -1) {
                        $scope.selectedOptions.splice(index, 1);
                    } else {
                        $scope.selectedOptions.push($scope.nameKey ? tag : {text: tag});
                    }
                    $scope.select();
                };
    
                /**
                 * [checkedTags description] 判断是否选中
                 * @param   {[type]}  tag  [tag description]
                 * @return  {[type]}       [return description]
                 */
                $scope.checkedTags = function(tag) {
                    var value = $scope.valueKey ? tag[$scope.valueKey] : tag;
                    var name = $scope.nameKey ? tag[$scope.nameKey] : tag;
                    $scope.selectedOptions = $scope.selectedOptions || [];
                    for (var i = 0; i < $scope.selectedOptions.length; i++) {
                        if (value === $scope.selectedOptions[i][$scope.valueKey || 'text'] && name === $scope.selectedOptions[i][$scope.nameKey || 'text']) {
                            return i;
                        }
                    }
                    return -1;
                };

                /**
                 * [bindBlur description] 绑定失焦事件
                 * @return {[type]} [description]
                 */
                function bindBlur() {
                    $('body').unbind('click', clickEvent).bind('click', clickEvent);
    
                    /**
                     * [clickEvent description] 点击事件
                     * @param  {[type]} e [description]
                     * @return {[type]}   [description]
                     */
                    function clickEvent(e) {
                        var $target = $(e.target);
                        if ($target.parents('.meizi-tags-input')[0] === iEle[0]) {
                            // 如果点到按键本身，不失焦
                            return;
                        }
                        $scope.options = [];
                    }
                    $scope.$on('$destroy', function() {
                        $('body').unbind('click', clickEvent);
                    });
                }
            },
        };
    }
]);
